import React, { useState, useEffect } from "react";
import "../App.css";

import Axios from "axios";

import {
    MDBBtn,
    MDBTable,
    MDBTableHead,
    MDBTableBody,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter, MDBModal, MDBTooltip,
} from "mdb-react-ui-kit";
import {Link, useNavigate} from "react-router-dom";

import {
    backendPathUsers,
} from "../Constants";
import TopNavbar from "../components/Navbar";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPen, faTrash} from "@fortawesome/free-solid-svg-icons";
import {checkWritePermission} from "../functions/permissions";


function Users() {
    const navigate = useNavigate();

    const [userList, setUserList] = useState([]);
    const [userToDelete, setUserToDelete] = useState({id: -1, name: ""});
    const [deletionPopupVisible, setDeletionPopupVisible] = useState(false);

    const [writePermission, setWritePermission] = useState(false);
    const [readPermission, setReadPermission] = useState(false);


    const getUsers = () => {
        Axios.get(backendPathUsers+"users.php").then((response) => {
            if (response.data) {
                if (response.data === "unauthorized") {
                    navigate("/login");
                } else {
                    setUserList(response.data);
                }
                console.log(response.data)
            }
        });
    };

    const deleteTask = () => {
        Axios.delete(`${backendPathUsers}delete-user.php?id=${userToDelete.id}`).then((response) => {
            getUsers();
        });
        setUserToDelete({id:-1, name:""});
        setDeletionPopupVisible(false);
    };

    const toggleShow = () => setDeletionPopupVisible(!deletionPopupVisible);

    useEffect(() => {
        checkWritePermission(navigate, setReadPermission, setWritePermission);
    }, []);

    useEffect(() => {
        getUsers();
    }, [writePermission]);


    return (
        <>

            <TopNavbar readPermissionInitial={readPermission} writePermissionInitial={writePermission}/>

            <div className="main">
                <div className="header-above-table d-flex align-items-center">
                    <h2>Liste aller Zugangsdaten</h2>
                    <Link className="link calendar-h" to="/new-user">
                        <MDBBtn className="btn">hinzufügen</MDBBtn>
                    </Link>
                </div>

                <MDBTable align='middle'>
                    <MDBTableHead className="table-head">
                        <tr className="underlined-header">
                            <th scope='col'>Username</th>
                            <th scope='col'>Nutzertyp</th>
                            <th></th>
                        </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                        <tr className="table-body">
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        {userList
                            .map((val, key) => {
                                return (
                                    <tr key={key}>
                                        <td>{val["Username"]}</td>
                                        <td>{val["EditPermissions"] === '0' ? "einfacher Nutzer" : "Nutzerverwaltung und Finanzen"}</td>
                                        <td>
                                            <div style={{float: "right"}}>

                                                <MDBTooltip tag='a' title="bearbeiten">
                                                    <FontAwesomeIcon className='btn-icon-first trash-btn' icon={faPen}
                                                                     onClick={
                                                                         () => {
                                                                             navigate("/edit-user/" + String(val["UserID"]));
                                                                         }}/>
                                                </MDBTooltip>


                                                <MDBTooltip tag='a' title="löschen">
                                                    <FontAwesomeIcon className='btn-icon trash-btn' icon={faTrash}
                                                                     onClick={
                                                                         () => {
                                                                             setUserToDelete({
                                                                                 id: val["UserID"],
                                                                                 name: val["Username"]
                                                                             });
                                                                             setDeletionPopupVisible(true);
                                                                             console.log("del");
                                                                         }}/>
                                                </MDBTooltip>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                    </MDBTableBody>
                </MDBTable>

                <MDBModal show={deletionPopupVisible} tabIndex="-1">
                    <MDBModalDialog>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>Account löschen</MDBModalTitle>
                                <MDBBtn
                                    className="btn-close"
                                    color="none"
                                    onClick={toggleShow}
                                ></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody>
                                Soll der Account von <b>{userToDelete.name}</b> wirklich gelöscht werden?
                            </MDBModalBody>

                            <MDBModalFooter>
                                <MDBBtn className="btn-light" onClick={toggleShow}>
                                    Abbrechen
                                </MDBBtn>
                                <MDBBtn onClick={deleteTask}>Löschen</MDBBtn>
                            </MDBModalFooter>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>

            </div>
        </>
    );
}

export default Users;